import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
const rows = [{
  label: 'Volume 01 — Root-Cause Clinical Assessment',
  price: '$27 USD'
}, {
  label: 'Volume 02 — Functional Lab Interpretation',
  price: '$27 USD'
}, {
  label: 'Volume 03 — Meal Engineering System',
  price: '$27 USD'
}, {
  label: 'Volume 04 — Clinical Protocol Vault',
  price: '$27 USD'
}, {
  label: 'Volume 05 — Patient Education System',
  price: '$27 USD'
}, {
  label: 'Volume 06 — Practice Growth OS',
  price: '$27 USD'
}, {
  label: 'Bonus 01 — Clinical Forms & Templates Vault',
  price: '$47 USD'
}, {
  label: 'Bonus 02 — Patient Education Library',
  price: '$47 USD'
}, {
  label: 'Bonus 03 — 90-Day Practice Launch Blueprint',
  price: '$47 USD'
}, {
  label: 'Bonus 04 — Legal & Liability Safety Vault',
  price: '$47 USD'
}];
export function ValueStack() {
  return <section id="comprar" className="w-full scroll-mt-20 bg-white px-5 py-12 sm:py-20" data-id="element-251" data-mp="35qo9ppcn85ah">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[600px]" data-id="element-252" data-mp="1tg4tydherjok">
        <h2 className="text-center font-serif-display text-2xl font-bold text-slate sm:text-4xl" data-id="element-253" data-mp="1yeg3so7pdu6s">
          Everything You Get Today
        </h2>

        <div className="mt-6 rounded-2xl border border-sage/25 p-4 sm:mt-8 sm:p-6" data-id="element-254" data-mp="2c4jhgqsiofkm">
          <ul data-id="element-255" data-mp="2837pwfq31k9s">
            {rows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 border-b border-dashed border-sage/20 py-2 last:border-b-0 sm:py-2.5" data-id="element-256" data-mp="283zo7yb2dw3r">
                <span className="text-[13px] text-slate/80 sm:text-sm" data-id="element-257" data-mp="2h4o0ookt7oej">{row.label}</span>
                <span className="shrink-0 text-[13px] font-medium text-slate/60 sm:text-sm" data-id="element-258" data-mp="rphjh2bhqjwz">
                  {row.price}
                </span>
              </li>)}
          </ul>

          <div className="my-4 h-px w-full bg-sage/30" data-id="element-259" data-mp="2mt5uetuwu8t2" />

          <div className="flex items-center justify-between" data-id="element-260" data-mp="2muqoyjh85rqx">
            <span className="text-[13px] text-slate/60 sm:text-sm" data-id="element-261" data-mp="2rrqw6xpt90jm">Total System Value</span>
            <span className="text-lg font-medium text-slate/50 line-through sm:text-xl" data-id="element-262" data-mp="2vu433pgan4hz">
              $350 USD
            </span>
          </div>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-sage/10 py-5 text-center sm:py-6" data-id="element-263" data-mp="30ui971yc44dd">
            <span className="text-sm font-medium text-dark-green" data-id="element-264" data-mp="35rrwoc25y5yk">Your Investment Today</span>
            <span className="font-serif-display text-5xl font-bold text-sage sm:text-6xl" data-id="element-265" data-mp="3apa766vtwt8o">
              $27 USD
            </span>
            <p className="mt-2 px-4 text-xs text-slate/60 sm:text-sm" data-id="element-266" data-mp="3jjf3v6xn8yw4">
              One-Time Payment · No Subscription · Lifetime Access · Downloadable PDF
            </p>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-267" data-mp="3thm9itmhfuit">
          <div className="mb-8 flex flex-col items-center text-center" data-id="element-268" data-mp="3tinubptavvdq">
            <span className="text-xs font-bold tracking-widest text-dark-green uppercase" data-id="element-269" data-mp="7gokg9qpkaow">
              Order Today and Get This FREE Fast-Action Bonus
            </span>
            <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-slate sm:text-3xl" data-id="element-270" data-mp="2jexr1uped4r">
              The Clinical Protocol Expansion Pack™
            </h3>
            <p className="mt-2 text-base font-medium text-slate/70 sm:text-lg" data-id="element-271" data-mp="3pnl2tslsm56a">
              Complete specialized protocols for Thyroid, Celiac Disease, Pregnancy, Metabolic Detox, Menopause, and Sports Nutrition · 70 pages · Value $197 · FREE TODAY ONLY
            </p>
            
            <div className="mt-6 w-full overflow-hidden rounded-xl border border-sage/20 bg-slate-900 shadow-sm" data-id="element-272" data-mp="gfimwgqpzvad">
              <video src="https://cdn.magicpatterns.com/uploads/eiDKyQQgdB6CctdHUsrdGF/DRIVE NUTRI INGLES.MOV" controls playsInline preload="none" className="w-full h-auto max-h-[70vh] object-contain" data-id="element-273" data-mp="cezvuownit98" />
            </div>
          </div>

          <CTAButton label="YES! GET MY COMPLETE SYSTEM NOW" href="https://nutri-prosystem.impultienda.ar/checkout" data-id="element-274" data-mp="tnhluyu0k0no" />
          <TodayOfferCard data-id="element-275" data-mp="fo82xrefasg0" />
          <div className="mt-4 rounded-xl border border-sage/20 bg-sage/5 px-4 py-3 text-center" data-id="element-276" data-mp="fp1dz4kf043y">
            <p className="text-sm font-bold text-dark-green" data-id="element-277" data-mp="jq36z3nqnjxh">💱 Pay Easily from Any Country</p>
            <p className="mt-1 text-xs leading-relaxed text-slate/70 sm:text-sm" data-id="element-278" data-mp="17g77v39jl5ks">
              Although the price is displayed in USD, the platform automatically converts to your local currency at checkout. You can complete your purchase with your regular card, with no calculations or extra steps needed.
            </p>
            <p className="mt-2 text-xs leading-relaxed text-slate/60" data-id="element-279" data-mp="12mctmfcphit3">
              Before confirming, you will see the exact amount in your local currency based on your payment method's exchange rate.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}